export const fssaiNumbers = [
  { branch: "Delhi", fssai: "13322999001007" },
  { branch: "Haryana", fssai: "10823005000099" },
  { branch: "Madhya Pradesh", fssai: "11423850000024" },
  { branch: "Punjab", fssai: "12122801000636" },
  { branch: "Rajasthan", fssai: "12222026002008" },
  { branch: "Tamil Nadu", fssai: "12423004000001" },
  { branch: "Uttar Pradesh", fssai: "12722055001219" },
  { branch: "Bihar", fssai: "10425000002077" },
];
